import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Flex, Select, Text } from "@mantine/core";
import { AppModal } from "../../shared/AppModal";
import { useForm, yupResolver } from "@mantine/form";
import { useDeleteAndReplacePriorityStatusMutation, useGetPriorityStatusesQuery } from "../../graphql/graphql";
import { showErrorNotification } from "../../shared/Notifications";
import { DeletePriorityStatusInitialValues, DeletePriorityStatusSchema } from "./DeletePriorityStatusModal.validation";
export const DeletePriorityStatusModal = ({ priorityStatus, opened, close }) => {
    const [_, deletePriorityStatus] = useDeleteAndReplacePriorityStatusMutation();
    const [{ data, fetching }] = useGetPriorityStatusesQuery();
    const priorityStatuses = (data?.priorityStatuses?.priorityStatuses ?? []).filter((status) => status !== null &&
        priorityStatus.priorityStatusId !== status.priorityStatusId);
    const form = useForm({
        mode: "controlled",
        initialValues: DeletePriorityStatusInitialValues,
        validate: yupResolver(DeletePriorityStatusSchema)
    });
    const handleDelete = async (event) => {
        event.preventDefault();
        const valid = form.validate();
        if (valid.hasErrors)
            return;
        const formValues = form.getValues();
        try {
            await deletePriorityStatus({
                priorityStatusIdToDelete: priorityStatus.priorityStatusId,
                priorityStatusIdToReplaceWith: formValues.replacementStatusId
            });
            handleClose();
        }
        catch (error) {
            console.error("An error occurred while deleting the referral stage.", error);
            showErrorNotification();
        }
    };
    const handleClose = () => {
        close();
        form.reset();
    };
    return (_jsxs(AppModal, { title: `Delete ${priorityStatus.name}?`, size: "md", opened: opened, onClose: handleClose, children: [_jsx(Text, { variant: "body-strong", children: `To delete this referral stage, you must select a replacement referral stage.` }), _jsx(Select, { label: "Replacement Referral Stage", placeholder: "Replacement Referral Stage", style: { marginTop: "1rem" }, data: priorityStatuses
                    .map((status) => {
                    if (!status)
                        return null;
                    return {
                        value: status?.priorityStatusId,
                        label: status?.name ?? ""
                    };
                })
                    .filter((status) => status !== null), ...form.getInputProps("replacementStatusId") }), _jsxs(Flex, { variant: "dialog-actions", gap: "md", children: [_jsx(Button, { variant: "outline", color: "gray", onClick: (event) => {
                            event.stopPropagation();
                            handleClose();
                        }, children: "Cancel" }), _jsx(Button, { variant: "filled", color: "var(--mantine-color-red-5)", loading: fetching, disabled: !form.values.replacementStatusId, onClick: handleDelete, children: "Delete" })] })] }));
};
